import { AreaSizes } from '@/models/prices.model';

export const getAppraiserPriceLabel = ({ max, min }: { min?: number | null; max?: number | null }) => {
  if (min == null || min === AreaSizes.small) return AreaSizes[AreaSizes.small];

  if (max == null) return AreaSizes[AreaSizes.large];

  return AreaSizes[AreaSizes.medium];
};
